function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, ref, watch } from "vue";
import { btnOption, moreBtnOption, auditBtnOption, particleCaasOption } from "../config/option";
import { definePropType } from "@types-vue/props";
import { openVisibleDialog } from "../config/dialog";
import { Operation, TabsType } from "../config/enums";
import { downloadAsset } from "@/api/public_resource";
import { noSupportedDelete, noSupportedAudit } from "@/views/producer/video-template/index";
import store from "@/store";
import _ from "lodash";
export default defineComponent({
    name: "batch-modular",
    props: {
        checkedRow: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    setup: function setup(props) {
        var downloadLoading = ref(false);
        var batchBtnOption = ref([]);
        var resource = computed(function() {
            return store.state.resource;
        });
        watch(function() {
            return resource.value.activeTab;
        }, function(val) {
            if (val === 0) {
                batchBtnOption.value = btnOption;
            } else if (val === TabsType.FRAGMENT) {
                batchBtnOption.value = moreBtnOption.filter(function(s) {
                    return [
                        Operation.BATCHDE,
                        Operation.UPLOW
                    ].includes(s.type);
                }).concat(auditBtnOption);
            } else {
                batchBtnOption.value = _.cloneDeep(moreBtnOption);
                if (val === TabsType.PARTICLE) {
                    // 粒子下载有caas特殊处理
                    batchBtnOption.value.splice(2, 0, particleCaasOption);
                }
            }
            console.log(batchBtnOption.value);
        }, {
            immediate: true
        });
        var handleBatchClick = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(btn) {
                var _$ref, tableIds, paramObj, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            tableIds = (_$ref = Array.from(props.checkedRow, function(param) {
                                var id = param.id;
                                return id;
                            })) !== null && _$ref !== void 0 ? _$ref : [];
                            if (!(btn.type !== Operation.DOWNLOAD)) {
                                _ctx.next = 16;
                                break;
                            }
                            if (!(resource.value.activeTab === TabsType.FRAGMENT)) {
                                _ctx.next = 12;
                                break;
                            }
                            if (!(btn.type === Operation.BATCHDE)) {
                                _ctx.next = 9;
                                break;
                            }
                            if (!noSupportedDelete(props.checkedRow)) {
                                _ctx.next = 7;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 7:
                            _ctx.next = 12;
                            break;
                        case 9:
                            if (!(btn.type === Operation.AUDIT)) {
                                _ctx.next = 12;
                                break;
                            }
                            if (!noSupportedAudit(props.checkedRow)) {
                                _ctx.next = 12;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 12:
                            openVisibleDialog();
                            resource.value.dialogFormInfo = {
                                id: tableIds.toString(),
                                value: btn.value,
                                operation: btn.type
                            };
                            _ctx.next = 30;
                            break;
                        case 16:
                            downloadLoading.value = true;
                            _ctx.prev = 17;
                            paramObj = {
                                ids: tableIds.toString()
                            };
                            if (btn.type === Operation.DOWNLOAD && btn.value === "fixParticlePath") {
                                // caas粒子路径fix
                                Object.assign(paramObj, {
                                    replace: 1
                                });
                            }
                            _ctx.next = 22;
                            return downloadAsset(paramObj);
                        case 22:
                            res = _ctx.sent;
                            window.open(res.data.data.download_url, "_blank");
                            downloadLoading.value = false;
                            _ctx.next = 30;
                            break;
                        case 27:
                            _ctx.prev = 27;
                            _ctx.t0 = _ctx["catch"](17);
                            downloadLoading.value = false;
                        case 30:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        17,
                        27
                    ]
                ]);
            }));
            return function handleBatchClick(btn) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            batchBtnOption: batchBtnOption,
            downloadLoading: downloadLoading,
            handleBatchClick: handleBatchClick
        };
    }
});
